import React from "react";
import { Card, Col, Descriptions, Image, Row, Skeleton, Space, Typography } from "antd";

const { Title } = Typography;

type DescriptionItem = {
  key: string;
  label: React.ReactNode;
  children: React.ReactNode;
};

interface Props {
  headNo?: string | number;
  title?: React.ReactNode;
  items: DescriptionItem[];
  imageSrc: string;
  imageHeight?: number;
  isLoading?: boolean;
}

const TrunkHeadDetailsCard: React.FC<Props> = ({
  headNo = "-",
  title,
  items,
  imageSrc,
  imageHeight = 300,
  isLoading = false,
}) => {
  return (
    <Card bordered className="head-details-card">
      <Space direction="vertical" size="large" className="w-100">
        <Title level={4} className="text-center m-0">
          {title ?? `Head ${headNo}`}
        </Title>

        {isLoading ? (
          <Skeleton active paragraph={{ rows: 3 }} />
        ) : (
          <>
            <Descriptions title="" column={1}>
              {items.map((item) => (
                <Descriptions.Item
                  key={item.key}
                  label={item.label}
                  labelStyle={{ display: "block", fontWeight: "bold", color: "#595959" }}
                  contentStyle={{ display: "block" }}
                >
                  {item.children}
                </Descriptions.Item>
              ))}
            </Descriptions>

            <Row justify="center">
              <Col>
                <Image
                  src={imageSrc}
                  className="trunk-image"
                  style={{ maxWidth: "100%", height: imageHeight }}
                  preview={false}
                />
              </Col>
            </Row>
          </>
        )}
      </Space>
    </Card>
  );
};

export default TrunkHeadDetailsCard;
